import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../../hooks/use-theme'
import { buildBaseChartOption, getAnalyticsColors, type AnalyticsThemeMode } from './echartsTheme'

export function useAnalyticsTheme() {
 const { resolvedTheme } = useTheme()
 const { i18n } = useTranslation()
 const mode: AnalyticsThemeMode = resolvedTheme === 'dark' ? 'dark' : 'light'
 const rtl = i18n.dir() === 'rtl'

 return useMemo(
  () => ({
   mode,
   rtl,
   colors: getAnalyticsColors(mode),
   baseOption: buildBaseChartOption(mode, rtl),
  }),
  [mode, rtl],
 )
}
